import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { graphql } from 'gatsby';
import { RichTextBlock } from 'prismic-reactjs';

import { RichText } from 'components/Prismic';

interface IPrimaryContent {
  primaryTitle: RichTextBlock[];
  primaryDescription: RichTextBlock[];
  secondaryTitle: RichTextBlock[];
}

const Container = styled.div`
  display: grid;
  position: relative;
  row-gap: 7.25rem;
  z-index: 1;
  background-color: #d003;
  padding: 26rem 0 6.125rem 12.125rem;
`;

const Content = styled.div`
  display: flex;
  column-gap: 14rem;
  justify-self: flex-end;
`;

const PrimaryTitle = styled(RichText)`
  ${({ theme: { colors, tp } }) => css`
    display: flex;
    align-self: flex-start;

    & > h2 {
      text-align: right;
      line-height: 1.04;
      letter-spacing: -0.1em;
      color: ${colors.white};
      font-size: 15rem;

      ${tp.useFont(fonts => fonts.Switzer.light)};
    }
  `}
`;

const PrimaryDescription = styled(RichText)`
  ${({ theme: { colors, tp } }) => css`
    display: flex;
    background-color: ${colors.black}33;
    width: 125rem;
    height: 74.75rem;

    & > p {
      padding: 2rem 24.75rem 0 3.25rem;
      text-align: left;
      line-height: 1.2;
      color: ${colors.white};
      font-size: 3.5rem;

      ${tp.useFont(fonts => fonts.Switzer.light)};
    }
  `}
`;

const SecondaryTitle = styled(RichText)`
  ${({ theme: { colors, tp } }) => css`
    display: flex;
    align-self: flex-end;

    & > h2 {
      padding-left: 1.75rem;
      text-shadow: 0.25rem 0.125rem 0.875rem #646464;
      line-height: 0.905;
      letter-spacing: -0.1em;
      color: ${colors.black};
      font-size: 12.25rem;

      ${tp.useFont(fonts => fonts.Switzer.light)};

      strong {
        font-size: 13.75rem;
      }
    }
  `}
`;
const PrimaryContent: React.FC<IPrimaryContent> = ({
  primaryTitle,
  primaryDescription,
  secondaryTitle,
}) => {
  return (
    <Container>
      <Content>
        <PrimaryTitle render={primaryTitle} />
        <PrimaryDescription render={primaryDescription} />
      </Content>
      <SecondaryTitle render={secondaryTitle} />
    </Container>
  );
};

export const desktopDualBlockTextSingleBackgroundPrimaryContentFragment = graphql`
  fragment SolutionDesktopDualBlockTextSingleBackgroundPrimaryContentData on PrismicSolutionDataDesktopSolutionDualBlockTextSingleBackground {
    primary {
      solution_dual_block_text_single_background_primary_title {
        richText
      }
      solution_dual_block_text_single_background_primary_description {
        richText
      }
    }
  }
`;

export default PrimaryContent;
